import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SmartHaus from '../views/SmartHaus.vue'
import Kanban from "../views/Kanban";
import Monitor from "../views/Monitor";
import Dev from "../views/Dev";

import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {title: "Arne Reckhaus aus Garbsen – Solution Architect & Lead Developer"}
  },
  {
    path: '/smarthaus',
    name: 'SmartHaus',
    component: SmartHaus,
    meta: {title: "Reckhaus - Smarthaus"}
  },
  {
    path: '/kanban',
    name: 'Kanban',
    component: Kanban,
    meta: {title: "Reckhaus - Kanban"}
  },
  {
    path: '/monitor',
    name: 'Monitor',
    component: Monitor,
    meta: {title: "Reckhaus - Monitor"}
  },
  {
    path: '/dev',
    name: 'Dev',
    component: Dev,
    meta: {title: "Reckhaus - Entwickler"}
  }
]

const router = new VueRouter({
  routes
})

export default router

const publicPaths = ["/", "/dev"];

// Es gibt keinen Login mehr: alle nicht-öffentlichen Views brauchen das Backend
// unter /api, das nginx aufs Heimnetz beschränkt (von außen 403). Gate ist
// deshalb store.state.general.localNetwork — der Backend-Ping aus App.vue.
router.beforeEach((to, from, next) => {
  const allowed =
    publicPaths.includes(to.path) ||
    store.state.general.localNetwork
  if (!allowed) {
    next('/'); // von außen: zurück auf die öffentliche Startseite
  } else {
    next(); // Continue to the route
  }
});
